import React, { useState } from 'react';
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';
import useOutsideClickHandler from 'hooks/useOutsideClickHandler';

import './index.css';

type DropdownProps = {
    className?: string;
    width: number;
    data: any[];
    dataKey?: string;
    disabled?: boolean;
    onSelect: (value: any) => void;
    label?: string;
    placeholder?: string;
    required?: boolean;
    value?: any;
}

function Dropdown({
    className,
    width,
    data,
    dataKey,
    disabled,
    onSelect,
    label,
    placeholder,
    required,
    value
}: DropdownProps) {
    const [isOpen, setIsOpen] = useState(false);

    const ref = useOutsideClickHandler(() => setIsOpen(false));

    const selectItem = (item: any) => {
        onSelect(item);
        setIsOpen(false);
    }

    return (
        <div
            className={disabled
                ? `dropdown4--disabled ${className}`
                : isOpen
                ? `dropdown4--open ${className}`
                : `dropdown4 ${className}`
            } 
            style={{maxWidth: `${width}px`}}
            ref={ref}
        >
            {label &&
                <p className='dropdown4__label'>
                    {label} {required && '*'}
                </p>
            }
            <div className='dropdown4__value' onClick={() => !disabled && setIsOpen(!isOpen)}>
                {value
                    ?   <p>{value.replace('ACT ', '').replace('Mathematics', 'Math')}</p>
                    :   placeholder
                    ?   <p className='dropdown4__placeholder'>
                            {placeholder}
                        </p>
                    :   ''
                }
                {!disabled && isOpen &&
                    <div className='dropdown4__items'> 
                        {data.map((item, i) => (
                            <p
                                key={i} 
                                className='dropdown4__item'
                                onClick={() => selectItem(item)}
                            >
                                {dataKey ? item[dataKey].replace('ACT ', '').replace('Mathematics', 'Math') : item.replace('ACT ', '').replace('Mathematics', 'Math')}
                            </p>
                        ))}
                    </div>
                }
                {isOpen
                    ? <FaChevronUp className='dropdown4__icon' />
                    : <FaChevronDown className='dropdown4__icon' />
                }
            </div>
        </div>
    );
}

export default Dropdown;